import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import Input from '@/components/UI/Input';
import { EFPhone } from '@/components/UI/svg/Support';
import seoconfig from '@/seoconfig/cooperation';
import { createDealer, getCitiesList, getCountriesList, getStatesList } from '@/service';
import { isReadyLang, redirectTo404 } from '@/utils';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { message as antdMessage, Button, Checkbox, Form, Select } from 'antd';
import { useRouter } from 'next/router';
import { GetServerSidePropsContext } from 'next/types';
import { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import css from './index.module.scss';
// import CooperationH5 from '@/componentsH5/cooperation';
// import CooperationPC from '@/components/cooperation';
import CooperationUS from '@elem/compPage/Cooperation';
// import { EmailForm } from '@/components/UI/EFEmailForm';
import NextImage from '@/components/NextImage';
import Image from '@/components/UI/Image';
import ProductLineup from '@/components/UI/svg/cooperation/ProductLineup';
import { ENGLISH_LANG, rpcMap } from '@/constants';
import { MODAL_TYPE } from '@/constants/cooperation';
import { INIT_COUNTRY_MAP } from '@/constants/quote';
import { submitFreeQuoteToB } from '@/service/quote';
const { EFPic } = createEFPic('/media/cooperation/');
const { EFPic: EFPicH5 } = createEFPic('/media/cooperation/h5/');
const { EFPic: EFPicPc } = createEFPic('/media/cooperation/pc/');
const INPUT_EMAIL_SITE = ['eu', 'de', 'fr', 'uk', 'it', 'es'];
const cnFormLink = 'https://wenjuan.feishu.cn/m/cfm?t=sLakzarz9YGi-v9qb';
const Icon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 80 80" version="1.1">
        <defs>
            <filter colorInterpolationFilters="auto" id="filter-1">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.149020 0 0 0 0 0.450980 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="编组-128备份-3" transform="translate(-2004.000000, -2069.000000)" filter="url(#filter-1)">
                <g transform="translate(2004.000000, 2069.000000)">
                    <rect id="矩形" x="0" y="0" width="80" height="80" />
                    <g id="编组-123" transform="translate(11.000000, 11.000000)" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <path
                            d="M13.5964776,3.41848348 L3.46819427,3.41848348 C1.55375103,3.41848348 0,4.97107845 0,6.88667775 L0,54.3338874 C0,56.2494867 1.55375103,57.8020817 3.46819427,57.8020817 L26.1629015,57.8020817"
                            id="Stroke-57"
                        />
                        <path
                            d="M47.5863999,27.2115678 L47.5863999,6.88679336 C47.5863999,4.97119406 46.0338049,3.41859909 44.1182056,3.41859909 L33.9910784,3.41859909"
                            id="Stroke-59"
                        />
                        <line x1="13.5964776" y1="23.8125062" x2="34.901595" y2="23.8125062" id="Stroke-61" />
                        <line x1="13.5964776" y1="37.408637" x2="29.5756046" y2="37.408637" id="Stroke-63" />
                        <path
                            d="M57.302893,31.5973307 L57.2427776,31.5372153 C56.3133015,30.6077393 54.8057931,30.6077393 53.8774731,31.5372153 L35.0856405,50.3278919 L31.5214928,57.3798869 L38.6012334,53.6654508 L57.302893,34.9637913 C58.232369,34.0343152 58.232369,32.5268067 57.302893,31.5973307 Z"
                            id="Stroke-65"
                        />
                        <line x1="52.4844151" y1="32.9294641" x2="55.910991" y2="36.35604" id="Stroke-67" />
                        <path
                            d="M31.678602,7.06933598 L15.9087227,7.06933598 C14.6312712,7.06933598 13.5965932,6.03465802 13.5965932,4.75720647 L13.5965932,2.31212951 C13.5965932,1.03467796 14.6312712,0 15.9087227,0 L31.678602,0 C32.9548975,0 33.9907315,1.03467796 33.9907315,2.31212951 L33.9907315,4.75720647 C33.9907315,6.03465802 32.9548975,7.06933598 31.678602,7.06933598 Z"
                            id="Stroke-69"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
const Icon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 80 80" version="1.1">
        <defs>
            <filter colorInterpolationFilters="auto" id="filter-1">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.149020 0 0 0 0 0.450980 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="编组-129备份-3" transform="translate(-2235.000000, -2069.000000)" filter="url(#filter-1)">
                <g transform="translate(2235.000000, 2069.000000)">
                    <rect id="矩形备份-46" x="0" y="0" width="80" height="80" />
                    <g id="编组-127" transform="translate(5.000000, 15.000000)" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <path
                            d="M16.5585804,12.9956397 C20.7051436,12.9956397 24.0660195,16.3565155 24.0660195,20.5019935 C24.0660195,24.6485568 20.7051436,28.0094326 16.5585804,28.0094326 C12.4131023,28.0094326 9.05222651,24.6485568 9.05222651,20.5019935 C9.05222651,16.3565155 12.4131023,12.9956397 16.5585804,12.9956397 Z"
                            id="Stroke-1"
                        />
                        <polyline
                            id="Stroke-3"
                            points="16.5612934 28.0133393 20.8152918 35.3818723 22.814237 31.3373182 27.3167471 31.6281528 23.0627486 24.2596198"
                        />
                        <polyline
                            id="Stroke-5"
                            points="10.0552803 24.2599453 5.80128184 31.6284783 10.3037919 31.3376438 12.3027371 35.3811127 16.5567355 28.0136649"
                        />
                        <path
                            d="M44.6843468,46.3892018 L3.28274114,46.3892018 C1.46936579,46.3892018 0,45.0044819 0,43.2963713 L0,3.09283049 C0,1.3847199 1.46936579,0 3.28274114,0 L62.3807632,0 C64.1941386,0 65.6645896,1.3847199 65.6645896,3.09283049 L65.6645896,25.0378193"
                            id="Stroke-7"
                        />
                        <line x1="32.3862761" y1="12.3708879" x2="56.4452417" y2="12.3708879" id="Stroke-9" />
                        <line x1="32.3862761" y1="23.1948179" x2="56.4452417" y2="23.1948179" id="Stroke-11" />
                        <line x1="32.3862761" y1="34.0190735" x2="45.3761642" y2="34.0190735" id="Stroke-13" />
                        <path
                            d="M70.0743147,38.9168148 C70.0743147,45.0373636 65.1127635,50 58.9922147,50 C52.8705808,50 47.9090295,45.0373636 47.9090295,38.9168148 C47.9090295,32.796266 52.8705808,27.8336296 58.9922147,27.8336296 C65.1127635,27.8336296 70.0743147,32.796266 70.0743147,38.9168148 Z"
                            id="Stroke-15"
                        />
                        <polyline id="Stroke-17" points="52.261673 39.6946888 56.572102 44.0051178 65.7214543 34.8568508" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
const Icon3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 80 80" version="1.1">
        <defs>
            <filter colorInterpolationFilters="auto" id="filter-1">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.149020 0 0 0 0 0.450980 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="编组-130备份-3" transform="translate(-2466.000000, -2069.000000)" filter="url(#filter-1)">
                <g transform="translate(2466.000000, 2069.000000)">
                    <rect id="矩形备份-47" x="0" y="0" width="80" height="80" />
                    <g id="编组-124" transform="translate(8.000000, 12.000000)" stroke="#333333" strokeLinecap="round" strokeWidth="2">
                        <path
                            d="M46.4002583,51.2002367 L32.0288397,51.2002367 C30.2457292,51.2002367 28.8005165,49.7550241 28.8005165,47.9719136 L28.8005165,38.3999354 L47.9713755,38.3999354 C49.754486,38.3999354 51.1996987,36.9547228 51.1996987,35.1716123 L51.1996987,25.5996341 L60.7716768,25.5996341 C62.5547873,25.5996341 64,27.0448468 64,28.8279573 L64,47.9719136 C64,49.7550241 62.5547873,51.2002367 60.7716768,51.2002367 L56.0002152,51.2002367 L51.1996987,55.9996772 L46.4002583,51.2002367 Z"
                            id="Stroke-19"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M3.22832316,4.89357134e-13 L47.971806,4.89357134e-13 C49.7549165,4.89357134e-13 51.2001291,1.44521267 51.2001291,3.22832316 L51.2001291,35.1715047 C51.2001291,36.9546152 49.7549165,38.3998278 47.971806,38.3998278 L20.8000861,38.3998278 L14.4004735,44.8005165 L8.00086089,38.3998278 L3.22832316,38.3998278 C1.44521267,38.3998278 0,36.9546152 0,35.1715047 L0,3.22832316 C0,1.44521267 1.44521267,4.89357134e-13 3.22832316,4.89357134e-13 Z"
                            id="Stroke-21"
                            strokeLinejoin="round"
                        />
                        <line x1="23.7243012" y1="19.2000215" x2="25.8765166" y2="19.2000215" id="Stroke-23" />
                        <line x1="34.9241075" y1="19.2000215" x2="37.0763229" y2="19.2000215" id="Stroke-25" />
                        <line x1="12.5239568" y1="19.2000215" x2="14.6761723" y2="19.2000215" id="Stroke-27" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
const Icon4 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 80 80" version="1.1">
        <defs>
            <filter colorInterpolationFilters="auto" id="filter-1">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.149020 0 0 0 0 0.450980 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="编组-131备份-3" transform="translate(-1773.000000, -2310.000000)" filter="url(#filter-1)">
                <g transform="translate(1773.000000, 2310.000000)">
                    <rect id="矩形备份-48" x="0" y="0" width="80" height="80" />
                    <g id="编组-125" transform="translate(12.000000, 10.000000)" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <line x1="15.001602" y1="22.3838161" x2="38.6833389" y2="22.3838161" id="Stroke-37" />
                        <line x1="15.0282187" y1="29.8097576" x2="38.0267143" y2="29.8097576" id="Stroke-39" />
                        <line x1="15.0282187" y1="37.237125" x2="28.8201866" y2="37.237125" id="Stroke-41" />
                        <line x1="32.9795219" y1="51.1018136" x2="4.97613536" y2="51.1018136" id="Stroke-43" />
                        <line x1="44.4570248" y1="12.9354804" x2="44.4570248" y2="33.8331576" id="Stroke-45" />
                        <line x1="14.7961543" y1="0.594122852" x2="41.22868" y2="0.594122852" id="Stroke-47" />
                        <path
                            d="M0,38.6290361 L9.22910438,38.6290361 L9.22910438,46.4869049 C9.22910438,49.0356919 7.1627451,51.1020512 4.61395807,51.1020512 C2.06517103,51.1020512 0,49.0356919 0,46.4869049 L0,38.6290361 Z"
                            id="Stroke-49"
                        />
                        <path
                            d="M14.7961543,0.594122852 L42.1020406,0.594122852 C46.6518334,0.594122852 50.3401481,4.28243752 50.3401481,8.83104207 L50.3401481,12.854442 L20.4747805,12.854442 L20.4747805,6.21690152 C20.4747805,3.1120155 17.9580761,0.594122852 14.8520019,0.594122852 C11.7471159,0.594122852 9.22922321,3.1120155 9.22922321,6.21690152 L9.22922321,38.3660773"
                            id="Stroke-51"
                        />
                        <path
                            d="M38.0081777,32.0185876 C43.5287672,32.0185876 48.0037005,36.4935209 48.0037005,42.0141104 C48.0037005,47.5347 43.5287672,52.0096333 38.0081777,52.0096333 C32.4875881,52.0096333 28.0126548,47.5347 28.0126548,42.0141104 C28.0126548,36.4935209 32.4875881,32.0185876 38.0081777,32.0185876 Z"
                            id="Stroke-53"
                        />
                        <line x1="46.0044771" y1="50.0107664" x2="56" y2="60.0062892" id="Stroke-55" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
const Icon5 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 80 80" version="1.1">
        <defs>
            <filter colorInterpolationFilters="auto" id="filter-1">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.149020 0 0 0 0 0.450980 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="编组-132备份-3" transform="translate(-2004.000000, -2310.000000)" filter="url(#filter-1)">
                <g transform="translate(2004.000000, 2310.000000)">
                    <rect id="矩形备份-49" x="0" y="0" width="80" height="80" />
                    <g id="编组-126" transform="translate(8.000000, 14.000000)" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <path
                            d="M31.9998949,51.9834051 L0.923953211,20.9074634 C-0.307984404,19.6755258 -0.307984404,17.6794085 0.923953211,16.4474709 L16.4482592,0.923164855 C17.6791457,-0.307721618 19.675263,-0.307721618 20.9072006,0.923164855 L31.9998949,12.0158591 M31.9998949,51.9834051 L51.9831423,32.0001577 L45.3220598,38.6612401 L38.6609774,45.3223226 L31.9998949,51.9834051 Z"
                            id="Stroke-29"
                        />
                        <path
                            d="M20.342948,23.6731213 L32.0001051,12.0159642 L20.342948,23.6731213 Z M20.342948,23.6731213 L43.0927994,0.923269969 C44.3236858,-0.307616504 46.3208543,-0.307616504 47.5517408,0.923269969 L63.0760468,16.447576 C64.3079844,17.6784624 64.3079844,19.6756309 63.0760468,20.9065174 L51.9833525,31.9992116 L38.6611876,18.6770467 L28.6690383,28.669196 L20.342948,23.6731213 Z"
                            id="Stroke-31"
                        />
                        <line x1="38.6613978" y1="45.3221124" x2="33.6653232" y2="40.3260378" id="Stroke-33" />
                        <line x1="45.3223752" y1="38.6608197" x2="40.3263005" y2="33.664745" id="Stroke-35" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

type Option = {
    key?: number | string;
    label: string;
    value: string;
};

type OptionMap = {
    [key: string]: Option[];
};

const Cooperation = ({ lang, SEO }: any) => {
    const { useLang, gtm, isMobile } = useGlobal();
    // const CooperationCom = isMobile ? CooperationH5 : CooperationPC;
    const NewBanner = isMobile ? NewBannerH5 : NewBannerPC;
    const { t: s } = useLang('shared');
    const { t } = useLang('cooperation');
    const router = useRouter();
    const { locale = 'us' } = router;
    const SECRET_KEY = INPUT_EMAIL_SITE?.includes(locale)
        ? process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY_TO_B
        : process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
    const recaptchaRef = useRef();
    const waitTimer = useRef<any>(null);
    const partnerTimer = useRef<any>(null);

    const [countries, setCountries] = useState<any>([]);
    const [states, setStates] = useState<any>([]);
    const [cities, setCities] = useState<any>([]);
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [prefixCode, setPrefixCode] = useState('');
    const [step, setStep] = useState(MODAL_TYPE.DETAIL);
    const [isLoading, setIsLoading] = useState(false);
    const [showCompanyTypeSpecify, setShowCompanyTypeSpecify] = useState(false);
    const [selectOpen, setSelectOpen] = useState({
        countryOpen: false,
        provinceOpen: false,
        cityOpen: false,
        companyType: false,
        businessCategory: false,
        productInterests: false,
        productCategory: false,
        licensed: false,
    });
    const [form] = Form.useForm();
    // 显示邮箱输入
    const SHOW_EMAIL_INPUT = INPUT_EMAIL_SITE.includes(locale);
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];

    useEffect(() => {
        if (locale === 'us') {
            const data = require(`elem/compPage/Business/config/times/us.js`);
            const timeLine = data.timeLine || null; // 代码保存的时间线

            const time = new Date().getTime(); // 服务器时区北京时区
            let currentTime = time;
            let { _timer } = router.query;

            if (_timer) {
                // 读取url上的时间进行测试
                const _timer2 = `${_timer} GMT+8`;
                currentTime = new Date(_timer2).getTime();
            }
            let pageStatus = currentTime >= timeLine.statusA.start ? '301' : '';
            if (pageStatus === '301') {
                window.location.href = `/us/energy-solutions-for-business${_timer ? `?_timer=${_timer}` : ''}`;

            }
        }
    }, [])

    const OTHER_COUNTRY2 = [
        {
            key: 404,
            label: t('other_country'),
            value: t('other_country'),
            phoneCode: '',
        },
    ];
    const OTHER_STATE: Option[] = [
        {
            key: 404,
            value: t('other_state'),
            label: t('other_state'),
        },
    ];
    const OTHER_CITY: Option[] = [
        {
            key: 404,
            value: t('other_city'),
            label: t('other_city'),
        },
    ];
    const categoriesLocaleMap: OptionMap = {
        us: [
            {
                label: t('outdoor_recreation'),
                value: t('outdoor_recreation'),
            },
            {
                label: t('rv'),
                value: t('rv'),
            },
            {
                label: t('construction'),
                value: t('construction'),
            },
            {
                label: t('disaster_relief'),
                value: t('disaster_relief'),
            },
            {
                label: t('others'),
                value: t('others'),
            },
        ],
        ca: [
            {
                value: t('catagory_item1'),
                label: t('catagory_item1'),
            },
            {
                value: t('catagory_item2'),
                label: t('catagory_item2'),
            },
            {
                value: t('catagory_item3'),
                label: t('catagory_item3'),
            },
            {
                value: t('catagory_item4'),
                label: t('catagory_item4'),
            },
            {
                value: t('catagory_item5'),
                label: t('catagory_item5'),
            },
            {
                value: t('catagory_item6'),
                label: t('catagory_item6'),
            },
            {
                value: t('catagory_item7'),
                label: t('catagory_item7'),
            },
            {
                value: t('catagory_item8'),
                label: t('catagory_item8'),
            },
            {
                value: t('catagory_item9'),
                label: t('catagory_item9'),
            },
            {
                value: t('catagory_item10'),
                label: t('catagory_item10'),
            },
            {
                value: t('catagory_item11'),
                label: t('catagory_item11'),
            },
            {
                value: t('catagory_item12'),
                label: t('catagory_item12'),
            },
            {
                value: t('catagory_item13'),
                label: t('catagory_item13'),
            },
            {
                value: t('catagory_item14'),
                label: t('catagory_item14'),
            },
            {
                value: t('catagory_item15'),
                label: t('catagory_item15'),
            },
        ],
        eu: [
            {
                label: t('catagory_item1'),
                value: t('catagory_item1'),
            },
            {
                label: t('catagory_item2'),
                value: t('catagory_item2'),
            },
            {
                label: t('catagory_item3'),
                value: t('catagory_item3'),
            },
            {
                label: t('catagory_item4'),
                value: t('catagory_item4'),
            },
            {
                label: t('catagory_item5'),
                value: t('catagory_item5'),
            },
            {
                label: t('catagory_item6'),
                value: t('catagory_item6'),
            },
            {
                label: t('catagory_item7'),
                value: t('catagory_item7'),
            },
            {
                label: t('catagory_item8'),
                value: t('catagory_item8'),
            },
            {
                label: t('catagory_item9'),
                value: t('catagory_item9'),
            },
            {
                label: t('catagory_item10'),
                value: t('catagory_item10'),
            },
            {
                label: t('catagory_item11'),
                value: t('catagory_item11'),
            },
            {
                label: t('catagory_item12'),
                value: t('catagory_item12'),
            },
        ],
        au: [
            {
                label: 'Battery/Generator',
                value: 'Battery/Generator',
            },
            {
                label: 'Solar/Energy Storage',
                value: 'Solar/Energy Storage',
            },
            {
                label: 'RV/Trailer/Upfitter/Overland',
                value: 'RV/Trailer/Upfitter/Overland',
            },
            {
                label: 'Outdoors/Camping Equipment',
                value: 'Outdoors/Camping Equipment',
            },
            {
                label: 'Consumer Electronics',
                value: 'Consumer Electronics',
            },
            {
                label: 'Home Appliance/Improvment',
                value: 'Home Appliance/Improvment',
            },
            {
                label: 'Emergency Preparedness/Safety',
                value: 'Emergency Preparedness/Safety',
            },
            {
                label: 'Yachts/Boats',
                value: 'Yachts/Boats',
            },
            {
                label: 'Government/Institution',
                value: 'Government/Institution',
            },
            {
                label: 'Outdoor Recreation',
                value: 'Outdoor Recreation',
            },
            {
                label: 'RV',
                value: 'RV',
            },
            {
                label: 'Construction',
                value: 'Construction',
            },
            {
                label: 'Disaster Relief',
                value: 'Disaster Relief',
            },
            {
                label: 'Others',
                value: 'Others',
            },
        ],
        za: [
            {
                label: 'Battery/Generator',
                value: 'Battery/Generator',
            },
            {
                label: 'Solar/Energy Storage',
                value: 'Solar/Energy Storage',
            },
            {
                label: 'RV/Trailer/Upfitter/Overland',
                value: 'RV/Trailer/Upfitter/Overland',
            },
            {
                label: 'Outdoors/Camping Equipment',
                value: 'Outdoors/Camping Equipment',
            },
            {
                label: 'Consumer Electronics',
                value: 'Consumer Electronics',
            },
            {
                label: 'Home Appliance/Improvment',
                value: 'Home Appliance/Improvment',
            },
            {
                label: 'Emergency Preparedness/Safety',
                value: 'Emergency Preparedness/Safety',
            },
            {
                label: 'Yachts/Boats',
                value: 'Yachts/Boats',
            },
            {
                label: 'Government/Institution',
                value: 'Government/Institution',
            },
            {
                label: 'Outdoor Recreation',
                value: 'Outdoor Recreation',
            },
            {
                label: 'RV',
                value: 'RV',
            },
            {
                label: 'Construction',
                value: 'Construction',
            },
            {
                label: 'Disaster Relief',
                value: 'Disaster Relief',
            },
            {
                label: 'Others',
                value: 'Others',
            },
        ],
    };
    const categories = categoriesLocaleMap[['uk', 'de', 'fr', 'it', 'es', 'cis'].includes(locale) ? 'eu' : locale] || categoriesLocaleMap.us;
    const companyTypeOption1: Option[] = [
        {
            label: t('site_dealer_companyType_item1'),
            value: 'Distributor',
        },
        {
            label: t('site_dealer_companyType_item2'),
            value: 'Installer',
        },
        {
            label: t('site_dealer_companyType_item3'),
            value: 'Electrician',
        },
        {
            label: t('site_dealer_companyType_item4'),
            value: 'Homeowner',
        },
        {
            label: t('site_dealer_companyType_item5'),
            value: 'Consultant',
        },
        {
            label: t('site_dealer_companyType_item6'),
            value: 'Media',
        },
        {
            label: t('site_dealer_companyType_item7'),
            value: 'Wholesaler',
        },
        {
            label: t('site_dealer_companyType_item9'),
            value: 'Others',
        },
    ];
    const companyTypeOption2: Option[] = [
        {
            label: t('site_dealer_companyType_item1'),
            value: 'Distributor',
        },
        {
            label: t('site_dealer_companyType_item7'),
            value: 'Wholesaler',
        },
        {
            label: t('site_dealer_companyType_item8'),
            value: 'Retailer',
        },
        {
            label: t('site_dealer_companyType_item9'),
            value: 'Others',
        },
    ];
    const companyTypeOptionGroups: Record<string, Option[]> = {
        au: [
            {
                label: 'Distributor',
                value: 'Distributor',
            },
            {
                label: 'Wholesaler',
                value: 'Wholesaler',
            },
            {
                label: 'Chain Retailer',
                value: 'Chain Retailer',
            },
            {
                label: 'local communicty store',
                value: 'local communicty store',
            },
            {
                label: 'Installer',
                value: 'Installer',
            },
            {
                label: 'Electrician',
                value: 'Electrician',
            },
            {
                label: 'Homeowner',
                value: 'Homeowner',
            },
            {
                label: 'Consultant',
                value: 'Consultant',
            },
            {
                label: 'Constructor',
                value: 'Constructor',
            },
            {
                label: 'Media',
                value: 'Media',
            },
            {
                label: 'Others',
                value: 'Others',
            },
        ],
        za: [
            {
                label: 'Distributor',
                value: 'Distributor',
            },
            {
                label: 'Wholesaler',
                value: 'Wholesaler',
            },
            {
                label: 'Chain Retailer',
                value: 'Chain Retailer',
            },
            {
                label: 'local communicty store',
                value: 'local communicty store',
            },
            {
                label: 'Installer',
                value: 'Installer',
            },
            {
                label: 'Electrician',
                value: 'Electrician',
            },
            {
                label: 'Homeowner',
                value: 'Homeowner',
            },
            {
                label: 'Consultant',
                value: 'Consultant',
            },
            {
                label: 'Constructor',
                value: 'Constructor',
            },
            {
                label: 'Media',
                value: 'Media',
            },
            {
                label: 'Others',
                value: 'Others',
            },
        ],
        ca: [
            {
                label: 'Distributor',
                value: 'Distributor',
            },
            {
                label: 'Wholesaler',
                value: 'Wholesaler',
            },
            {
                label: 'Chain Retailer',
                value: 'Chain Retailer',
            },
            {
                label: 'local communicty store',
                value: 'local communicty store',
            },
            {
                label: 'Installer',
                value: 'Installer',
            },
            {
                label: 'Electrician',
                value: 'Electrician',
            },
            {
                label: 'Homeowner',
                value: 'Homeowner',
            },
            {
                label: 'Consultant',
                value: 'Consultant',
            },
            {
                label: 'Constructor',
                value: 'Constructor',
            },
            {
                label: 'Media',
                value: 'Media',
            },
            {
                label: 'Others',
                value: 'Others',
            },
        ],
    };
    const [companyTypeOption, setCompanyTypeOption] = useState(['za', 'au', 'ca'].includes(locale) ? companyTypeOptionGroups[locale] : companyTypeOption1);
    const productInterestsOption: Option[] = [
        {
            label: t('site_dealer_product_interests_item1'),
            value: 'Home solar battery solution',
        },
        {
            label: t('site_dealer_product_interests_item2'),
            value: 'Power stations',
        },
        {
            label: t('site_dealer_product_interests_item3'),
            value: 'Balcony power plants',
        },
        {
            label: t('site_dealer_product_interests_item4'),
            value: 'Solar panels',
        },
        {
            label: t('site_dealer_product_interests_item5'),
            value: 'Smart devices',
        },
        {
            label: t('site_dealer_product_interests_item6'),
            value: 'Others',
        },
    ];
    const productCategoryOption = [
        {
            label: t('site_dealer_productCategory_item5'),
            value: t('site_dealer_productCategory_item5'),
        },
        {
            label: t('site_dealer_productCategory_item6'),
            value: t('site_dealer_productCategory_item6'),
        },
        {
            label: t('site_dealer_productCategory_item1'),
            value: t('site_dealer_productCategory_item1'),
        },
        {
            label: t('site_dealer_productCategory_item2'),
            value: t('site_dealer_productCategory_item2'),
        },
        {
            label: t('site_dealer_productCategory_item3'),
            value: t('site_dealer_productCategory_item3'),
        },
        {
            label: t('site_dealer_productCategory_item4'),
            value: t('site_dealer_productCategory_item4'),
        },
        {
            label: t('site_dealer_productCategory_item7'),
            value: t('site_dealer_productCategory_item7'),
        },
        {
            label: t('site_dealer_productCategory_item8'),
            value: t('site_dealer_productCategory_item8'),
        },
        {
            label: t('site_dealer_productCategory_item9'),
            value: t('site_dealer_productCategory_item9'),
        },
    ];

    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        form.setFieldsValue({
            recaptchaResponse: captchaCode,
        });
    };

    const onFinish = async (values: any) => {
        const params: any = {
            businessCategory: ' ',
            ...values,
            email: values.email.trim(),
            phoneCode: prefixCode,
            recaptchaResponse,
            optIn: !!values.optIn,
        };
        //  jp改版后country字段不再展示了
        if (locale === 'jp') {
            params.country = 'Japan';
        }
        if (locale === 'ca') {
            const productLineups = [values.productLineup, values.productLineup2, values.productLineup3].filter((item) => item !== undefined);
            params.productLineup = productLineups.join('/');
            if (['Yes', 'No'].includes(values.licensedElectricianConstructor)) {
                params.licensedElectricianConstructor = values.licensedElectricianConstructor === 'Yes';
            } else {
                delete params.licensedElectricianConstructor;
            }
        }
        setIsLoading(true);
        try {
            let res;
            if (INPUT_EMAIL_SITE.includes(locale)) {
                params['addressLineTwo'] = params.address2;
                params['postalCode'] = params.zipCode;
                params['phoneNumber'] = params.phoneCode + params.phone;
                params['identity'] = params.companyType;
                params['interestedProductCategory'] = params.productInterests;
                res = await submitFreeQuoteToB(params, locale);
            } else {
                res = await createDealer(params);
            }
            setIsLoading(false);
            if (res.code === '0') {
                form.resetFields();
                setStep(MODAL_TYPE.SUCCESS);
                anchorTo('.form-box');
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'become_dealer_submit',
                    status: 'success',
                });
                antdMessage.success(res?.message || 'Success');
            } else {
                setRecaptchaResponse('');
                const rptRef: any = recaptchaRef.current;
                rptRef.reset();
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'become_dealer_submit',
                    status: 'fail',
                });
                antdMessage.error(res?.message);
            }
            if (SHOW_EMAIL_INPUT) {
                /* @ts-ignore */
                window?.lintrk('track', { conversion_id: 13465498 });
                /* @ts-ignore */
                window?.fbq && window?.fbq('track', 'Lead');
            }
        } catch (err: any) {
            setIsLoading(false);
            console.log('err:', err);
            gtm.push({
                event: 'uaEvent',
                event_name: 'become_dealer_submit',
                status: 'fail',
            });
        }
    };

    const getCity = async (id: number) => {
        try {
            const res: any = await getCitiesList({
                stateId: id,
                page: 1,
                size: 3000,
            });

            if (res.code === '0') {
                const cityList: any = res.data?.content?.map((item: any) => ({
                    key: item.id,
                    label: item.name,
                    value: item.name,
                }));
                setCities(SHOW_EMAIL_INPUT ? cityList.concat(OTHER_CITY) : cityList);
            } else {
                antdMessage.error(res?.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getStates = async (id: number) => {
        try {
            const res: any = await getStatesList({
                countryId: id,
                page: 1,
                size: 300,
            });
            if (res.code === '0') {
                const stateList = res.data?.content?.map((item: any) => ({
                    key: item.id,
                    value: item.name,
                    label: item.name,
                }));
                setStates(SHOW_EMAIL_INPUT ? stateList.concat(OTHER_STATE) : stateList);
                return stateList;
            } else {
                antdMessage.error(res?.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onStateChange = (_val: any, option: any) => {
        form.setFieldsValue({
            city: undefined,
        });
        getCity(option.key);
    };

    const onCountryChange = (_val: any, option: any) => {
        // select组件重置值，也会把placeholder清除，所以提前获取值判断是否存在值
        form.setFieldsValue({
            state: undefined,
        });
        form.setFieldsValue({
            city: undefined,
        });
        const target = countries.filter((item: any) => item.key === Number(option.key));
        getStates(option.key);
        setPrefixCode(target[0]?.phoneCode);
        setCities([]);
    };

    const onCompanyTypeChange = (item: any) => setShowCompanyTypeSpecify(item == 'Others');

    const onProductInterestsChange = (item: any) => {
        if (locale !== 'za' && locale !== 'au') {
            setCompanyTypeOption(item === productInterestsOption[0]?.value ? companyTypeOption1 : companyTypeOption2);
            form.setFieldsValue({
                companyType: undefined,
            });
        }
    };

    const anchorTo = (target: string) => {
        const ele = document.querySelector(target);
        if (ele) {
            ele.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const onClickPartner = () => {
        if (locale !== 'cn') {
            anchorTo('.form-box');
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_banner',
                banner_name: 'Become a Dealer',
                position: 'banner_1',
                button_name: 'become_an_ecoflow_partner',
            });
            if (SHOW_EMAIL_INPUT) {
                /* @ts-ignore */
                window?.lintrk('track', { conversion_id: 13618346 });
            }
        } else {
            window.open(cnFormLink);
        }
    };

    const getCountry = async () => {
        const firstCountries = [
            {
                key: 82,
                label: 'Germany',
                value: 'Germany',
                phoneCode: '+49',
            },
            {
                key: 15,
                label: 'Austria',
                value: 'Austria',
                phoneCode: '+43',
            },
            {
                key: 214,
                label: 'Switzerland',
                value: 'Switzerland',
                phoneCode: '+41',
            },
        ];
        // 因国家/省/市列表只有英文的，所以暂时写死语言为 us
        const result: any = await getCountriesList(
            {
                page: 1,
                size: 300,
            },
            'us',
        );
        if (result?.code === '0') {
            const countryList: any = [];
            result.data?.content?.forEach((item: any) => {
                countryList.push({
                    key: item.id,
                    text: item.name,
                    phoneCode: item.phoneCode,
                });
            });
            countryList.push({
                key: 404,
                text: t('other_country'),
                phoneCode: '',
            });
            setCountries(countryList);
        }
    };

    const handleInitCountry = () => {
        form.setFieldsValue({ country: INIT_COUNTRY_MAP[locale]?.name || 'Germany' });
        getStates(INIT_COUNTRY_MAP[locale]?.id || 82);
    };

    useEffect(() => {
        getCountry();

        waitTimer.current = setTimeout(() => {
            handleInitCountry();
        }, 300);

        if (locale === 'za') {
            partnerTimer.current = setTimeout(() => {
                // Linkedin insight 埋点
                const _linkedin_partner_id = '6360538';
                window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                window._linkedin_data_partner_ids.push(_linkedin_partner_id);
            }, 2000);
        }
    }, []);

    return (
        <PageLayout>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            {locale === 'us' && <CooperationUS countryList={countries} />}
            {locale !== 'us' && (
                <div className={`${css.cooperation} container`}>
                    {SHOW_EMAIL_INPUT && <NewBanner t={t} onClick={onClickPartner} />}
                    {!SHOW_EMAIL_INPUT && (
                        <div className="top-container">
                            <div className="bg">
                                {isMobile ? (
                                    <EFPicH5 name={[`top_bg_m.webp`, `top_bg_m.jpg`]} alt={t('site_dealer_title')} className="cooperationBg" />
                                ) : (
                                    <EFPicPc name={[`top_bg.webp`, `top_bg.jpg`]} alt={t('site_dealer_title')} className="cooperationBg" />
                                )}
                            </div>
                            <div className="container bottomPosition">
                                <div className="content">
                                    <h1 className="top-title">{t('site_dealer_title')}</h1>
                                    <div className={`link-to-join ${!isMobile ? 'pc-link' : ''}`} onClick={onClickPartner}>
                                        <span className="link-to-join-text">{t('site_dealer_become_partner')}</span>
                                        <span className="more">
                                            <Image src="/icons/arrow-white.svg" layout="fill" alt={t('site_dealer_icon')} />
                                        </span>
                                    </div>
                                    <div className="desc">{t('site_dealer_become_partner_tip')}</div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="base-box partner-box">
                        <div className="multi-title">{t('site_dealer_why_partner')}</div>
                        <div className="cards-content">
                            <div className="card-item">
                                <div className="icon-card1"></div>
                                <div className="card-item-title">{t('site_dealer_direct_cooperation')}</div>
                                <div className="card-item-desc">{t('site_dealer_direct_cooperation_tip')}</div>
                            </div>
                            {SHOW_EMAIL_INPUT && (
                                <div className="card-item">
                                    <div className="icon-card4">
                                        <ProductLineup />
                                    </div>
                                    <div className="card-item-title">{t('site_dealer_lineup')}</div>
                                    <div className="card-item-desc">{t('site_dealer_lineup_desc')}</div>
                                </div>
                            )}
                            {!SHOW_EMAIL_INPUT && (
                                <div className="card-item">
                                    <div className="icon-card2"></div>
                                    <div className="card-item-title">{t('site_dealer_innovation')}</div>
                                    <div className="card-item-desc">{t('site_dealer_innovation_tip')}</div>
                                </div>
                            )}
                            <div className="card-item">
                                <div className="icon-card3"></div>
                                <div className="card-item-title">{t('site_dealer_support')}</div>
                                <div className="card-item-desc">{t('site_dealer_support_tip')}</div>
                            </div>
                        </div>
                    </div>
                    {/* 2023.0731 （JP）页面更新 https://ecoflow.feishu.cn/docx/ZYd8dRi0KoBJmpxq19QcPD4enCg */}
                    {locale !== 'jp' && (
                        <div className="base-box join-box">
                            <div className="top-title">{t('site_dealer_how_join')}</div>
                            <div className="cards-content">
                                <div
                                    className="card-item"
                                    onClick={() => locale === 'cn' && window.open(cnFormLink)}
                                    style={{ cursor: locale === 'cn' ? 'pointer' : 'unset' }}
                                >
                                    <div className="card-item-digital">1</div>
                                    <div className="card-item-content">
                                        <div className="icon-wrapper">
                                            <Icon1 />
                                        </div>
                                        <div className="title">{t('site_dealer_register')}</div>
                                        <div className="desc">{t('site_dealer_register_tip')}</div>
                                    </div>
                                </div>
                                <div className="card-item">
                                    <div className="card-item-digital">2</div>
                                    <div className="card-item-content">
                                        <div className="icon-wrapper">
                                            <Icon2 />
                                        </div>
                                        <div className="title">{t('site_dealer_eligibility_review')}</div>
                                        <div className="desc">{t('site_dealer_application_check')}</div>
                                    </div>
                                </div>
                                <div className="card-item">
                                    <div className="card-item-digital">3</div>
                                    <div className="card-item-content">
                                        <div className="icon-wrapper">
                                            <Icon3 />
                                        </div>
                                        <div className="title">{t('site_dealer_get_in_touch')}</div>
                                        <div className="desc">{t('site_dealer_get_in_touch_tip')}</div>
                                    </div>
                                </div>
                                <div className="card-item">
                                    <div className="card-item-digital">4</div>
                                    <div className="card-item-content">
                                        <div className="icon-wrapper">
                                            <Icon4 />
                                        </div>
                                        <div className="title">{t('site_dealer_review_terms_and_contracts')}</div>
                                        <div className="desc">{t('site_dealer_review_terms_and_contracts_tip')}</div>
                                    </div>
                                </div>
                                <div className="card-item">
                                    <div className="card-item-digital">5</div>
                                    <div className="card-item-content">
                                        <div className="icon-wrapper">
                                            <Icon5 />
                                        </div>
                                        <div className="title">{t('site_dealer_official_partner')}</div>
                                        <div className="desc">{t('site_dealer_official_partner_tip')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="base-box explore-box">
                        <div className="top-title">{t('site_dealer_explore_market')}</div>
                        <div className="subTitle">{t('site_dealer_explore_market_remark')}</div>
                        {SHOW_EMAIL_INPUT && (
                            <div className="explore-content explore-6">
                                <div className="explore-item">
                                    <NextImage
                                        webpSrc={require('@publicLocal/cooperation/explore_1.webp')}
                                        src={require('@publicLocal/cooperation/explore_1.jpg')}
                                        alt={t('explore_1')}
                                        aria-label={t('explore_1')}
                                    />
                                    <div className="img-title">{t('explore_1')}</div>
                                </div>
                                <div className="explore-item">
                                    <NextImage
                                        webpSrc={require('@publicLocal/cooperation/explore_2.webp')}
                                        src={require('@publicLocal/cooperation/explore_2.jpg')}
                                        alt={t('explore_2')}
                                        aria-label={t('explore_2')}
                                    />
                                    <div className="img-title">{t('explore_2')}</div>
                                </div>
                                <div className="explore-item">
                                    <NextImage
                                        webpSrc={require('@publicLocal/cooperation/explore_3.webp')}
                                        src={require('@publicLocal/cooperation/explore_3.jpg')}
                                        alt={t('explore_3')}
                                        aria-label={t('explore_3')}
                                    />
                                    <div className="img-title">{t('explore_3')}</div>
                                </div>
                                <div className="explore-item">
                                    <NextImage
                                        webpSrc={require('@publicLocal/cooperation/explore_4.webp')}
                                        src={require('@publicLocal/cooperation/explore_4.jpg')}
                                        alt={t('explore_4')}
                                        aria-label={t('explore_4')}
                                    />
                                    <div className="img-title">{t('explore_4')}</div>
                                </div>
                                <div className="explore-item">
                                    <NextImage
                                        webpSrc={require('@publicLocal/cooperation/explore_5.webp')}
                                        src={require('@publicLocal/cooperation/explore_5.jpg')}
                                        alt={t('explore_5')}
                                        aria-label={t('explore_5')}
                                    />
                                    <div className="img-title">{t('explore_5')}</div>
                                </div>
                                <div className="explore-item">
                                    <NextImage
                                        webpSrc={require('@publicLocal/cooperation/explore_6.webp')}
                                        src={require('@publicLocal/cooperation/explore_6.jpg')}
                                        alt={t('explore_6')}
                                        aria-label={t('explore_6')}
                                    />
                                    <div className="img-title">{t('explore_6')}</div>
                                </div>
                            </div>
                        )}
                        {!SHOW_EMAIL_INPUT && (
                            <div className="explore-content">
                                <div className="explore-item">
                                    <EFPic name={['explore_1.webp', 'explore_1.jpg']} alt={t('site_dealer_outdoor_recreation')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_outdoor_recreation')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic name={['explore_2.webp', 'explore_2.jpg']} alt={t('site_dealer_rvs_and_camping')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_rvs_and_camping')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic name={['explore_3.webp', 'explore_3.jpg']} alt={t('site_dealer_home_backup')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_home_backup')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic
                                        name={['explore_4.webp', 'explore_4.jpg']}
                                        alt={t('site_dealer_construction_and_diy')}
                                        className="exploreAndShadow"
                                    />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_construction_and_diy')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic name={['explore_5.webp', 'explore_5.jpg']} alt={t('site_dealer_marinas_and_sailing')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_marinas_and_sailing')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic name={['explore_6.webp', 'explore_6.jpg']} alt={t('site_dealer_disaster_relief')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_disaster_relief')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic name={['explore_7.webp', 'explore_7.jpg']} alt={t('site_dealer_renewable_energy')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_renewable_energy')}</div>
                                </div>
                                <div className="explore-item">
                                    <EFPic name={['explore_8.webp', 'explore_8.jpg']} alt={t('site_dealer_off-grid_living')} className="exploreAndShadow" />
                                    <EFPic name={['shadow.webp', 'shadow.png']} className="bgImgs exploreAndShadow" alt={t('site_dealer_shadow')} />
                                    <div className="img-title">{t('site_dealer_off-grid_living')}</div>
                                </div>
                            </div>
                        )}
                    </div>
                    {locale !== 'cn' && (
                        <div className="base-box form-box">
                            <div className="form-content">
                                {/* {step === MODAL_TYPE.EMAIL && <EmailForm onFinish={onFinishEmail} />} */}
                                {step === MODAL_TYPE.DETAIL && (
                                    <div id="cooperation-form">
                                        <div className="top-title">{t('site_dealer_become_a_dealer')}</div>
                                        <div className="top-desc">{t('site_dealer_become_a_dealer_remark')}</div>
                                        <Form name="cooperation" form={form} layout="vertical" onFinish={onFinish}>
                                            {locale === 'jp' && (
                                                <>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_company_name')}
                                                            name="companyName"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: s('my.site_dealer_table_company_name_wrong'),
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_company_name')}
                                                                aria-label={t('site_dealer_table_company_name')}
                                                                maxLength={200}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item label={t('site_dealer_table_department_name')} name="departmentName">
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_department_name')}
                                                                aria-label={t('site_dealer_table_department_name')}
                                                                maxLength={100}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item label={t('site_dealer_table_role')} name="role">
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_role')}
                                                                aria-label={t('site_dealer_table_role')}
                                                                maxLength={100}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_first_name')}
                                                            name="firstName"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,30}$/;
                                                                        if (!value || value?.length > 30 || !regx.test(value)) {
                                                                            return Promise.reject(s('user.site_account_profile_firstname_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_first_name')}
                                                                aria-label={t('site_dealer_table_first_name')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('site_dealer_table_last_name')}
                                                            name="lastName"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,30}$/;
                                                                        if (!value || value?.length > 30 || !regx.test(value)) {
                                                                            return Promise.reject(s('user.site_account_profile_lastname_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_last_name')}
                                                                aria-label={t('site_dealer_table_last_name')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_phone')}
                                                            name="phone"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^[0-9+]{7,20}$/;
                                                                        if (!regx.test(value)) {
                                                                            return Promise.reject(s('my.site_account_address_phone_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input vertical-line"
                                                                placeholder={t('site_dealer_table_phone')}
                                                                aria-label={t('site_dealer_table_phone')}
                                                                prefix={
                                                                    prefixCode && (
                                                                        <>
                                                                            <span>{prefixCode}</span>
                                                                            <div className="divider"></div>
                                                                        </>
                                                                    )
                                                                }
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('site_dealer_table_email_address')}
                                                            name="email"
                                                            rules={[
                                                                {
                                                                    validator: async (_: any, value: any) => {
                                                                        const regx =
                                                                            /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                                                        if (!regx.test(value)) {
                                                                            return Promise.reject(s('logintips.site_login_tip_email_format_incorrect'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                            validateTrigger="onBlur"
                                                            required
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_email_address')}
                                                                aria-label={t('site_dealer_table_email_address')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_postal_zip_code')}
                                                            name="zipCode"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^[a-zA-Z0-9\s]{1,50}$/;
                                                                        if (!value || !regx.test(value)) {
                                                                            return Promise.reject(s('user.site_account_address_zip_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_postal_zip_code')}
                                                                aria-label={t('site_dealer_table_postal_zip_code')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item label={t('site_dealer_table_state')} name="state">
                                                            <Input
                                                                className="default-input"
                                                                maxLength={100}
                                                                placeholder={t('site_dealer_table_state')}
                                                                aria-label={t('site_dealer_table_state')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item label={t('site_dealer_table_city')} name="city">
                                                            <Input
                                                                className="default-input"
                                                                maxLength={100}
                                                                placeholder={t('site_dealer_table_city')}
                                                                aria-label={t('site_dealer_table_city')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <Form.Item
                                                        name="companyAddress"
                                                        label={t('site_dealer_table_company_address')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: s('user.site_account_address_address_wrong_tip'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_company_address')}
                                                            aria-label={t('site_dealer_table_company_address')}
                                                            maxLength={200}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="businessForm"
                                                        label={t('site_dealer_table_business_form')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('site_dealer_table_business_form_wrong_tip'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_business_form')}
                                                            aria-label={t('site_dealer_table_business_form')}
                                                            maxLength={500}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="businessPlan"
                                                        label={t('site_dealer_table_business_plan')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('site_dealer_table_business_plan_wrong_tip'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_business_plan')}
                                                            aria-label={t('site_dealer_table_business_plan')}
                                                            maxLength={500}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        className="sales-targets"
                                                        name="salesTargets"
                                                        label={t('site_dealer_table_sales_target')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('site_dealer_table_sales_target_wrong_tip'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_sales_target')}
                                                            aria-label={t('site_dealer_table_sales_target')}
                                                            maxLength={50}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="salesChannel" label={t('site_dealer_table_sales_channel')}>
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_sales_channel')}
                                                            aria-label={t('site_dealer_table_sales_channel')}
                                                            maxLength={500}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="companyWebsite"
                                                        rules={[
                                                            {
                                                                validator(_: any, value: any) {
                                                                    const regx =
                                                                        /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
                                                                    if (value && !regx.test(value)) {
                                                                        return Promise.reject(
                                                                            new Error(s('user.site_account_address_company_website_wrong_tip')),
                                                                        );
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                        label={t('site_dealer_table_company_website')}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_company_website')}
                                                            aria-label={t('site_dealer_table_company_website')}
                                                            maxLength={150}
                                                        />
                                                    </Form.Item>
                                                </>
                                            )}
                                            {locale !== 'jp' && (
                                                <>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_first_name')}
                                                            name="firstName"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,30}$/;
                                                                        if (!value || value?.length > 30 || !regx.test(value)) {
                                                                            return Promise.reject(s('user.site_account_profile_firstname_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_first_name')}
                                                                aria-label={t('site_dealer_table_first_name')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('site_dealer_table_last_name')}
                                                            name="lastName"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,30}$/;
                                                                        if (!value || value?.length > 30 || !regx.test(value)) {
                                                                            return Promise.reject(s('user.site_account_profile_lastname_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_last_name')}
                                                                aria-label={t('site_dealer_table_last_name')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_country')}
                                                            name="country"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator: (_rule, value) =>
                                                                        value
                                                                            ? Promise.resolve()
                                                                            : Promise.reject(s('user.site_account_profile_country_select_wrong_tip')),
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                style={{ width: 336 }}
                                                                className="ef-comp-selector"
                                                                placeholder={t('site_dealer_table_country')}
                                                                onChange={onCountryChange}
                                                                optionFilterProp="children"
                                                                showSearch
                                                                onDropdownVisibleChange={(open) =>
                                                                    setSelectOpen({
                                                                        ...selectOpen,
                                                                        countryOpen: open,
                                                                    })
                                                                }
                                                                getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                suffixIcon={
                                                                    <div
                                                                        style={{
                                                                            transform: `rotate(${selectOpen.countryOpen ? '90deg' : '0deg'})`,
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src="/icons/arrow-black.svg"
                                                                            width={20}
                                                                            height={20}
                                                                            alt={t('site_dealer_icon')}
                                                                        />
                                                                    </div>
                                                                }
                                                                dropdownClassName="ef-select-item"
                                                            >
                                                                {countries?.map((item: any) => (
                                                                    <Select.Option value={item.text} key={item.key}>
                                                                        {item.text}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('site_dealer_table_state')}
                                                            name="state"
                                                            rules={[
                                                                {
                                                                    // required: true,
                                                                    // message: t('site_dealer_table_type_company_wrong'),
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                style={{ width: 336 }}
                                                                className="ef-comp-selector"
                                                                onChange={onStateChange}
                                                                placeholder={t('site_dealer_table_state')}
                                                                onDropdownVisibleChange={(open) =>
                                                                    setSelectOpen({
                                                                        ...selectOpen,
                                                                        provinceOpen: open,
                                                                    })
                                                                }
                                                                optionFilterProp="children"
                                                                showSearch
                                                                getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                suffixIcon={
                                                                    <div
                                                                        style={{
                                                                            transform: `rotate(${selectOpen.provinceOpen ? '90deg' : '0deg'})`,
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src="/icons/arrow-black.svg"
                                                                            width={20}
                                                                            height={20}
                                                                            alt={t('site_dealer_icon')}
                                                                        />
                                                                    </div>
                                                                }
                                                                dropdownClassName="ef-select-item"
                                                            >
                                                                {states?.map((item: any) => (
                                                                    <Select.Option value={item.value} key={item.key}>
                                                                        {item.value}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_city')}
                                                            name="city"
                                                            rules={[
                                                                {
                                                                    required: SHOW_EMAIL_INPUT,
                                                                    // message: t('site_dealer_table_type_company_wrong'),
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                style={{ width: 336 }}
                                                                className="ef-comp-selector"
                                                                placeholder={t('site_dealer_table_city')}
                                                                onDropdownVisibleChange={(open) =>
                                                                    setSelectOpen({
                                                                        ...selectOpen,
                                                                        cityOpen: open,
                                                                    })
                                                                }
                                                                optionFilterProp="children"
                                                                showSearch
                                                                getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                suffixIcon={
                                                                    <div
                                                                        style={{
                                                                            transform: `rotate(${selectOpen.cityOpen ? '90deg' : '0deg'})`,
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src="/icons/arrow-black.svg"
                                                                            width={20}
                                                                            height={20}
                                                                            alt={t('site_dealer_icon')}
                                                                        />
                                                                    </div>
                                                                }
                                                                dropdownClassName="ef-select-item"
                                                            >
                                                                {cities?.map((item: any) => (
                                                                    <Select.Option value={item.value} key={item.key}>
                                                                        {item.value}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('site_dealer_table_postal_zip_code')}
                                                            name="zipCode"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^[a-zA-Z0-9\s]{1,50}$/;
                                                                        if (!value || !regx.test(value)) {
                                                                            return Promise.reject(s('user.site_account_address_zip_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_postal_zip_code')}
                                                                aria-label={t('site_dealer_table_postal_zip_code')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_phone')}
                                                            name="phone"
                                                            required
                                                            rules={[
                                                                {
                                                                    validator(_: any, value: any) {
                                                                        const regx = /^[0-9+]{7,20}$/;
                                                                        if (!regx.test(value)) {
                                                                            return Promise.reject(s('my.site_account_address_phone_wrong_tip'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input vertical-line"
                                                                placeholder={t('site_dealer_table_phone')}
                                                                aria-label={t('site_dealer_table_phone')}
                                                                prefix={
                                                                    prefixCode && (
                                                                        <>
                                                                            <span>{prefixCode}</span>
                                                                            <div className="divider"></div>
                                                                        </>
                                                                    )
                                                                }
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={t('site_dealer_table_email_address')}
                                                            name="email"
                                                            rules={[
                                                                {
                                                                    validator: async (_: any, value: any) => {
                                                                        const regx =
                                                                            /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                                                        if (!regx.test(value)) {
                                                                            return Promise.reject(s('logintips.site_login_tip_email_format_incorrect'));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                            validateTrigger="onBlur"
                                                            required
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_email_address')}
                                                                aria-label={t('site_dealer_table_email_address')}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div className="two-colums">
                                                        <Form.Item
                                                            label={t('site_dealer_table_company_name')}
                                                            name="companyName"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: s('my.site_account_address_phone_wrong_tip'),
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="default-input"
                                                                placeholder={t('site_dealer_table_company_name')}
                                                                aria-label={t('site_dealer_table_company_name')}
                                                                maxLength={100}
                                                            />
                                                        </Form.Item>
                                                        {!SHOW_EMAIL_INPUT && (
                                                            <Form.Item
                                                                label={t('site_dealer_table_business_category')}
                                                                name="businessCategory"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: t('site_dealer_table_category_wrong'),
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    style={{ width: 336 }}
                                                                    className="ef-comp-selector"
                                                                    placeholder={t('site_dealer_table_business_category')}
                                                                    onDropdownVisibleChange={(open) =>
                                                                        setSelectOpen({
                                                                            ...selectOpen,
                                                                            businessCategory: open,
                                                                        })
                                                                    }
                                                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                    suffixIcon={
                                                                        <div
                                                                            style={{
                                                                                transform: `rotate(${selectOpen.businessCategory ? '90deg' : '0deg'})`,
                                                                            }}
                                                                        >
                                                                            <Image
                                                                                src="/icons/arrow-black.svg"
                                                                                width={20}
                                                                                height={20}
                                                                                alt={t('site_dealer_icon')}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    dropdownClassName="ef-select-item"
                                                                    options={categories}
                                                                />
                                                            </Form.Item>
                                                        )}
                                                        {SHOW_EMAIL_INPUT && (
                                                            <Form.Item
                                                                label={t('site_dealer_product_interests')}
                                                                name="productInterests"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: t('site_dealer_table_category_wrong'),
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    style={{ width: 336 }}
                                                                    className="ef-comp-selector"
                                                                    placeholder={t('site_dealer_product_interests')}
                                                                    onDropdownVisibleChange={(open) =>
                                                                        setSelectOpen({
                                                                            ...selectOpen,
                                                                            productInterests: open,
                                                                        })
                                                                    }
                                                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                    suffixIcon={
                                                                        <div
                                                                            style={{
                                                                                transform: `rotate(${selectOpen.productInterests ? '90deg' : '0deg'})`,
                                                                            }}
                                                                        >
                                                                            <Image
                                                                                src="/icons/arrow-black.svg"
                                                                                width={20}
                                                                                height={20}
                                                                                alt={t('site_dealer_icon')}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    dropdownClassName="ef-select-item"
                                                                    // options={productInterestsOption}
                                                                    onChange={(item) => onProductInterestsChange(item)}
                                                                >
                                                                    {productInterestsOption?.map((option: any) => (
                                                                        <Select.Option key={option?.value} value={option?.value}>
                                                                            {option?.label}
                                                                        </Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        )}
                                                    </div>
                                                    {(SHOW_EMAIL_INPUT || ['za', 'au', 'ca'].includes(locale)) && (
                                                        <div className="two-colums">
                                                            <Form.Item
                                                                label={t('site_dealer_type_of_company')}
                                                                name="companyType"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: t('site_dealer_table_type_company_wrong'),
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    style={{ width: 336 }}
                                                                    className="ef-comp-selector"
                                                                    placeholder={t('site_dealer_i_am_a')}
                                                                    onDropdownVisibleChange={(open) =>
                                                                        setSelectOpen({
                                                                            ...selectOpen,
                                                                            companyType: open,
                                                                        })
                                                                    }
                                                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                    suffixIcon={
                                                                        <div
                                                                            style={{
                                                                                transform: `rotate(${selectOpen.companyType ? '90deg' : '0deg'})`,
                                                                            }}
                                                                        >
                                                                            <Image
                                                                                src="/icons/arrow-black.svg"
                                                                                width={20}
                                                                                height={20}
                                                                                alt={t('site_dealer_icon')}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    dropdownClassName="ef-select-item"
                                                                    onChange={(item) => onCompanyTypeChange(item)}
                                                                >
                                                                    {companyTypeOption?.map((option: any) => (
                                                                        <Select.Option key={option?.value} value={option?.value}>
                                                                            {option?.label}
                                                                        </Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                            {/* new input */}
                                                            {showCompanyTypeSpecify && (
                                                                <Form.Item className="no-label" name="companyTypeSpecify">
                                                                    <Input
                                                                        style={{ width: 336, marginTop: 30 }}
                                                                        className="default-input full-width"
                                                                        placeholder={t('site_dealer_please_specify')}
                                                                        aria-label={t('site_dealer_please_specify')}
                                                                        maxLength={49}
                                                                    />
                                                                </Form.Item>
                                                            )}
                                                        </div>
                                                    )}
                                                    {locale === 'ca' && (
                                                        <>
                                                            <div className="two-colums">
                                                                <Form.Item label="Licensed Electrictian/Constructor?" name="licensedElectricianConstructor">
                                                                    <Select
                                                                        className="ef-comp-selector"
                                                                        onDropdownVisibleChange={(open) =>
                                                                            setSelectOpen({
                                                                                ...selectOpen,
                                                                                licensed: open,
                                                                            })
                                                                        }
                                                                        style={{ width: 336 }}
                                                                        getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                        suffixIcon={
                                                                            <div
                                                                                style={{
                                                                                    transform: `rotate(${selectOpen.licensed ? '90deg' : '0deg'})`,
                                                                                }}
                                                                            >
                                                                                <Image
                                                                                    src="/icons/arrow-black.svg"
                                                                                    width={20}
                                                                                    height={20}
                                                                                    alt={t('site_dealer_icon')}
                                                                                />
                                                                            </div>
                                                                        }
                                                                        dropdownClassName="ef-select-item"
                                                                        options={[
                                                                            {
                                                                                label: 'Yes',
                                                                                value: 'Yes',
                                                                            },
                                                                            {
                                                                                label: 'No',
                                                                                value: 'No',
                                                                            },
                                                                        ]}
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    label="What is your company size?"
                                                                    name="companySize"
                                                                    required
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Please enter your company size',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Input
                                                                        className="default-input"
                                                                        placeholder="company size"
                                                                        aria-label="What is your company size?"
                                                                        maxLength={200}
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <Form.Item
                                                                label="Numbers of Employees"
                                                                name="employeeNumber"
                                                                required
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please enter numbers of employees',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    className="default-input full-width"
                                                                    placeholder="employee number"
                                                                    aria-label="employee number"
                                                                    maxLength={200}
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                    <Form.Item
                                                        name="companyWebsite"
                                                        rules={[
                                                            {
                                                                validator(_: any, value: any) {
                                                                    const regx =
                                                                        /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
                                                                    if (value && !regx.test(value)) {
                                                                        return Promise.reject(
                                                                            new Error(s('user.site_account_address_company_website_wrong_tip')),
                                                                        );
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                        label={t('site_dealer_table_company_website')}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_company_website')}
                                                            aria-label={t('site_dealer_table_company_website')}
                                                            maxLength={150}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="companyAddress"
                                                        label={t('site_dealer_table_company_address')}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: s('user.site_account_address_address_wrong_tip'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_company_address')}
                                                            aria-label={t('site_dealer_table_company_address')}
                                                            maxLength={255}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="address2" label={t('site_dealer_table_address_line2')}>
                                                        <Input
                                                            className="default-input full-width"
                                                            placeholder={t('site_dealer_table_address_line2')}
                                                            aria-label={t('site_dealer_table_address_line2')}
                                                            maxLength={255}
                                                        />
                                                    </Form.Item>
                                                    {locale === 'ca' && (
                                                        <>
                                                            <Form.Item label={t('site_dealer_interested')} name="productCategory">
                                                                <Select
                                                                    className="ef-comp-selector full-width"
                                                                    placeholder={t('site_dealer_interested')}
                                                                    onDropdownVisibleChange={(open) =>
                                                                        setSelectOpen({
                                                                            ...selectOpen,
                                                                            productCategory: open,
                                                                        })
                                                                    }
                                                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                                                    suffixIcon={
                                                                        <div
                                                                            style={{
                                                                                transform: `rotate(${selectOpen.productCategory ? '90deg' : '0deg'})`,
                                                                            }}
                                                                        >
                                                                            <Image
                                                                                src="/icons/arrow-black.svg"
                                                                                width={20}
                                                                                height={20}
                                                                                alt={t('site_dealer_icon')}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    dropdownClassName="ef-select-item"
                                                                    options={productCategoryOption}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="valueProposition"
                                                                label="What is your value proposition that will help us drive net new business? "
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please enter this field',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input.TextArea
                                                                    className="default-input full-width"
                                                                    maxLength={2000}
                                                                    showCount={true}
                                                                    autoSize={{ minRows: 3 }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="cooperationGain"
                                                                label="What do you hope to gain by working with EcoFlow?"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please enter this field',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input.TextArea
                                                                    className="default-input full-width"
                                                                    maxLength={2000}
                                                                    showCount={true}
                                                                    autoSize={{ minRows: 3 }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="businessSuccess"
                                                                label="How would you define success by doing business with EcoFlow from quantitative and qualitative perpectives?"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please enter this field',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input.TextArea
                                                                    className="default-input full-width"
                                                                    maxLength={2000}
                                                                    showCount={true}
                                                                    autoSize={{ minRows: 3 }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="productLineup"
                                                                label="Tell us a little bit more about your product lineup or business main focuses"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please enter at least ONE focus product',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input className="default-input full-width" maxLength={1000} />
                                                            </Form.Item>
                                                            <Form.Item name="productLineup2">
                                                                <Input className="default-input full-width" maxLength={1000} />
                                                            </Form.Item>
                                                            <Form.Item name="productLineup3">
                                                                <Input className="default-input full-width" maxLength={1000} />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                            <Form.Item name="message" label={t('site_dealer_table_message')}>
                                                <Input.TextArea
                                                    className="default-input full-width"
                                                    placeholder={t('site_dealer_table_message_placeholder')}
                                                    aria-label={t('site_dealer_table_message_placeholder')}
                                                    maxLength={2000}
                                                    showCount={true}
                                                    autoSize={{ minRows: 3 }}
                                                />
                                            </Form.Item>
                                            {SHOW_EMAIL_INPUT && (
                                                <Form.Item name="optIn" className="checkbox" valuePropName="checked">
                                                    <Checkbox>{t('cooperation_form_checkbox')}</Checkbox>
                                                </Form.Item>
                                            )}

                                            <div>
                                                <Form.Item
                                                    name="recaptchaResponse"
                                                    rules={[
                                                        {
                                                            validator() {
                                                                if (recaptchaResponse) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(s('logintips.site_login_tip_perform_verification'));
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    <div className="g-recaptcha">
                                                        {/* @ts-ignore */}
                                                        <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                                    </div>
                                                </Form.Item>
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <Form.Item>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        className="black-btn submit-btn"
                                                        loading={isLoading}
                                                        aria-label={t('site_dealer_table_submit')}
                                                    >
                                                        {t('site_dealer_table_submit')}
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    </div>
                                )}
                                {step === MODAL_TYPE.SUCCESS && (
                                    <div className="register-success-wrapper">
                                        <div className="img-wrapper">
                                            <EFPic
                                                name={['register-success.webp', 'register-success.png']}
                                                alt={t('site_dealer_table_submit_success')}
                                                className="registerSuccess"
                                            />
                                        </div>
                                        <div className="title">{t('site_dealer_table_submit_success')}</div>
                                        <div className="desc">{t('site_dealer_table_submit_success_tip')}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {locale === 'cn' && (
                        <div onClick={() => window.open(cnFormLink)} className={!isMobile ? 'bottom-pc_contact' : 'bottom-mobile_contact'}>
                            {t('bottom_contact_us')}
                        </div>
                    )}
                    <div className="bottom-box">
                        <div className="bottom-text">{t('site_dealer_get_more')}</div>
                        <div className="link-wrapper">
                            {locale === 'cn' ? (
                                <EFPhone width={isMobile ? '0.28rem' : '40px'} height={isMobile ? '0.22rem' : '38px'} color="var(--global)" />
                            ) : (
                                <span className="icon-email"></span>
                            )}
                            <div className="link-text">{t('site_dealer_email')}</div>
                        </div>
                    </div>
                </div>
            )}
        </PageLayout>
    );
};

export default Cooperation;

export async function getServerSideProps({ locale = 'us' }: GetServerSidePropsContext) {
    if (['jp', 'br', 'mx'].includes(locale)) {
        return {
            redirect: {
                destination: `/${locale}`,
                permanent: true,
            },
        };
    }
    if (!isReadyLang(locale)) {
        return redirectTo404();
    }

    return {
        props: {},
    };
}

function NewBannerPC({ t, onClick }: any) {
    return (
        <div className={`${css.NewBannerPC} ef-cooperation-newb-anner`}>
            <NextImage
                webpSrc={require('@publicLocal/cooperation/pc/new_banner.webp')}
                src={require('@publicLocal/cooperation/pc/new_banner.jpg')}
                alt={t('new_banner_title')}
                aria-label={t('new_banner_title')}
            />
            <div className="text-wrapper">
                <p className="title">{t('new_banner_title')}</p>
                <p className="desc">{t('new_banner_desc')}</p>
                <p className="btn" onClick={onClick}>
                    {t('new_banner_btn')}
                </p>
            </div>
        </div>
    );
}

function NewBannerH5({ t, onClick }: any) {
    return (
        <div className={`${css.NewBannerH5} ef-cooperation-newb-anner`}>
            <NextImage
                webpSrc={require('@publicLocal/cooperation/h5/new_banner.webp')}
                src={require('@publicLocal/cooperation/h5/new_banner.jpg')}
                alt={t('new_banner_title')}
                aria-label={t('new_banner_title')}
            />
            <div className="text-wrapper">
                <p className="title">{t('new_banner_title')}</p>
                <p className="desc">{t('new_banner_desc')}</p>
                <p className="btn" onClick={onClick}>
                    {t('new_banner_btn')}
                </p>
            </div>
        </div>
    );
}
